module.exports = __webpack_public_path__ + "static/media/class_6.7266ec73.svg";